// @xing-com/hub isDarkMode is not reliable on logged out for now. until is fixed we can use this workaround
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { useAppliedTheme } from '@xing-com/hub';

export const useIsDarkMode = (): boolean => {
  const isDarkMode = useAppliedTheme() === 'dark';
  const { isLoggedOut } = useLoginState();

  if (isLoggedOut) return false;
  return isDarkMode;
};
